import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, switchMap, flatMap } from 'rxjs/operators';

import * as AccountPostingTypeActions from './account-posting-type.actions';
import { AccountAllocationsService } from '../account-allocations.service';
import { DisplayMessageMinimum, ResponseStatus } from '../../../shared';
import * as fromShared from '../../../shared';

@Injectable()
export class AccountPostingTypeEffects {
    getAccountPostingTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountPostingTypeActions.getAccountPostingTypes),
            switchMap(() =>
                this.service.getAccountPostingTypes().pipe(
                    flatMap(resp => [
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        r =>
                                            r.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        ),
                        AccountPostingTypeActions.loadAccountPostingTypes({
                            AccountPostingTypes: resp
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putAccountPostingTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AccountPostingTypeActions.putAccountPostingTypes),
            switchMap(action =>
                this.service
                    .putAccountPostingTypes(action.AccountPostingTypes)
                    .pipe(
                        concatMap(resp =>
                            fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                                ? [
                                      AccountPostingTypeActions.upsertAccountPostingTypes(
                                          {
                                              AccountPostingTypes: resp.Items
                                          }
                                      ),
                                      new fromShared.Errors.RemoveErrors(
                                          resp.Items.filter(
                                              x =>
                                                  x.Status.StatusCode ===
                                                  ResponseStatus.Success
                                          ).map(x => x.ListID.toString())
                                      )
                                  ]
                                : [
                                      new fromShared.Errors.SetErrors(
                                          fromShared.Errors.MapErrorsToStatus(
                                              resp
                                          )
                                      ),
                                      AccountPostingTypeActions.upsertAccountPostingTypes(
                                          {
                                              AccountPostingTypes: resp.Items
                                          }
                                      )
                                  ]
                        ),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        );
    });

    constructor(
        private actions$: Actions,
        private service: AccountAllocationsService
    ) {}
}
